var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'view/report', 'component/range-selector', 'template/download/landing.htm', 'common/location'], function($, core, ReportView, rangeSelector, landingTemplate, location) {
  var ReportDownloadPage;
  return ReportDownloadPage = (function(_super) {

    __extends(ReportDownloadPage, _super);

    function ReportDownloadPage() {
      ReportDownloadPage.__super__.constructor.apply(this, arguments);
    }

    ReportDownloadPage.prototype.pageId = 'download';

    /*
    # @param {Object} options contains id, title, icon, template
    # @param {Array} params additional information passed to widget with ID
    */


    ReportDownloadPage.prototype.initialize = function(options, params) {
      options = _.extend(options, {
        title: 'Download',
        icon: 'ss-gizmo ss-download',
        features: ['date-range'],
        template: landingTemplate
      });
      ReportDownloadPage.__super__.initialize.call(this, options, params);
      this.initReportDateIntervals();
      this.initUI();
      return this.updateLinks();
    };

    ReportDownloadPage.prototype.updateLinks = function() {
      var apiPrefix, client, clientId, endDate, intervalAsDates, intervalType, link, reportScale, serviceURL, startDate, _i, _len, _ref, _results;
      client = core.getCurrentClient().toJSON();
      clientId = client.id;
      serviceURL = location.apiRoot + location.reportingApiPath;
      apiPrefix = location.apiRoot + core.getConfig().apiPrefix;
      intervalType = rangeSelector.getIntervalType();
      reportScale = intervalType === 'YEAR' ? 'yearly' : intervalType === 'QUARTER' ? 'quarterly' : 'monthly';
      intervalAsDates = rangeSelector.getIntervalAsDates();
      endDate = intervalAsDates.to.toString('yyyy-MM-dd');
      startDate = intervalAsDates.from.toString('yyyy-MM-dd');
      this.newReportLinks = [
        {
          id: 'balance_sheet',
          url: serviceURL + ("balance-sheet/xls/" + clientId + "/" + reportScale + "/" + endDate)
        }, {
          id: 'gst_details',
          url: serviceURL + ("gst/xls/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'income_statement',
          url: serviceURL + ("income-statement/xls/" + clientId + "/" + reportScale + "/" + startDate + "/" + endDate)
        }, {
          id: 'income_statement_all_intervals',
          url: serviceURL + ("income-statement/xls/" + clientId + "/" + reportScale)
        }, {
          id: 'general_ledger',
          url: serviceURL + ("general-ledger/xls/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'general_ledger_internal',
          url: serviceURL + ("general-ledger/xls/internal/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'trial_balance',
          url: serviceURL + ("trial-balance/xls/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'transactions',
          url: serviceURL + ("view/xls/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'transactions_internal',
          url: serviceURL + ("view/xls/internal/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'tax_accountant_package',
          url: serviceURL + ("tax-accountant/zip/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'missing_receipts',
          url: serviceURL + ("missing-receipts/xls/" + clientId + "/" + startDate + "/" + endDate)
        }, {
          id: 'all_receipts',
          url: apiPrefix + ("file.json/client/" + clientId + "/receipts/download?from=" + startDate + "&to=" + endDate)
        }
      ];
      _ref = this.newReportLinks;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        link = _ref[_i];
        _results.push($("#" + link.id + "_report_link").attr('href', link.url));
      }
      return _results;
    };

    ReportDownloadPage.prototype.dateChangeAction = function() {
      this.updateReportURLFromInterval();
      return this.updateLinks();
    };

    return ReportDownloadPage;

  })(ReportView);
});
